<template>
  <svg
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    width="48"
    height="48"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24 6C14.0589 6 6 14.0589 6 24C6 33.9411 14.0589 42 24 42C33.9411 42 42 33.9411 42 24C42 14.0589 33.9411 6 24 6ZM2 24C2 11.8497 11.8497 2 24 2C36.1503 2 46 11.8497 46 24C46 36.1503 36.1503 46 24 46C11.8497 46 2 36.1503 2 24Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.5162 16.0486C23.5852 15.8889 22.6277 16.0639 21.8133 16.5425C20.9989 17.0212 20.3801 17.7726 20.0667 18.6637C19.7001 19.7057 18.5583 20.2532 17.5163 19.8867C16.4743 19.5201 15.9268 18.3783 16.2933 17.3363C16.9203 15.5541 18.1577 14.0513 19.7865 13.094C21.4153 12.1367 23.3304 11.7868 25.1925 12.1062C27.0546 12.4256 28.7435 13.3937 29.9602 14.8391C31.1767 16.2841 31.8425 18.113 31.84 20.0018C31.8391 23.0625 29.5699 25.0838 27.9494 26.1641C27.0781 26.7449 26.2211 27.172 25.5898 27.4526C25.2713 27.5942 25.0031 27.7016 24.8098 27.7752C24.713 27.8121 24.6345 27.8407 24.5774 27.861L24.5079 27.8853L24.4858 27.8929L24.478 27.8955L24.475 27.8965C24.475 27.8965 24.5079 27.8853 24.4725 27.8974C23.4246 28.2467 22.2919 27.6803 21.9426 26.6325C21.5936 25.5853 22.1589 24.4534 23.2055 24.1033L23.2374 24.0921C23.2681 24.0812 23.3186 24.0629 23.3858 24.0373C23.5207 23.9859 23.7212 23.9058 23.9652 23.7974C24.4589 23.578 25.1019 23.2551 25.7306 22.8359C27.1098 21.9164 27.84 20.9383 27.84 20L27.84 19.997C27.8414 19.0524 27.5085 18.1377 26.9001 17.4151C26.2918 16.6924 25.4473 16.2083 24.5162 16.0486Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22 34C22 32.8954 22.8954 32 24 32H24.02C25.1246 32 26.02 32.8954 26.02 34C26.02 35.1046 25.1246 36 24.02 36H24C22.8954 36 22 35.1046 22 34Z"
    />
  </svg>
</template>
